import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'

import WelcomeQuiz from './components/WelcomeQuiz/WelcomeQuiz'

import { getInitialQuiz } from 'src/api/quizzes/quizzes'
import { IQuiz } from 'src/api/quizzes/types'
import { LoadingScreen } from 'src/components/Loading'
import { COMPLETE_QUIZ } from 'src/constants/routes'

const Landing: FC = () => {
  const { push } = useHistory()

  const [initialQuiz, setInitialQuiz] = React.useState<IQuiz>()
  const [isLoading, setIsLoading] = React.useState(true)

  React.useEffect(() => {
    const fetchQuiz = async () => {
      try {
        const initialQuizData = await getInitialQuiz()
        setInitialQuiz(initialQuizData)
        if (initialQuizData.completed) {
          push(COMPLETE_QUIZ.replace(':id', String(initialQuizData.id)))
        }
      } catch (e) {
        console.error(e)
      }
      setIsLoading(false)
    }

    fetchQuiz()
  }, [push])

  if (isLoading) return <LoadingScreen />

  if (initialQuiz) return <WelcomeQuiz quiz={initialQuiz} />

  return <div>something is wrong</div>
}

export default Landing
